var _circle, _circle2, _circle3, _circle4, _path, _rect, _circle5, _circle6, _circle7, _circle8, _circle9, _path2, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path3, _rect2, _circle16, _circle17, _circle18, _circle19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeSpeakingEnglish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 75,
    fill: "#EDF1FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 2.5,
    fill: "#EDF1FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 30,
    r: 2.5,
    fill: "#EDF1FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 30,
    r: 2.5,
    fill: "#EDF1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9999 13C29.4771 13 24.9999 17.4772 24.9999 23V26.104L17.0406 30.7107C15.6514 31.5148 15.6536 33.5211 17.0445 34.3221L24.9999 38.9038V43C24.9999 48.5228 29.4771 53 34.9999 53H107C112.523 53 117 48.5228 117 43V23C117 17.4772 112.523 13 107 13H34.9999Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 8,
    transform: "translate(38 29)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 33,
    r: 4,
    fill: "#4F75FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 33,
    r: 4,
    fill: "#4F75FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 33,
    r: 4,
    fill: "#4F75FF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 33,
    r: 4,
    fill: "#4F75FF"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 33,
    r: 4,
    fill: "#4F75FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9999 105C26.4771 105 21.9999 109.477 21.9999 115V118.104L14.0406 122.711C12.6514 123.515 12.6536 125.521 14.0445 126.322L21.9999 130.904V135C21.9999 140.523 26.4771 145 31.9999 145H118C123.523 145 128 140.523 128 135V115C128 109.477 123.523 105 118 105H31.9999Z",
    fill: "#4F75FF"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 125,
    r: 4,
    fill: "#EDF1FF"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 125,
    r: 4,
    fill: "#EDF1FF"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 125,
    r: 4,
    fill: "#EDF1FF"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 125,
    r: 4,
    fill: "#EDF1FF"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 125,
    r: 4,
    fill: "#EDF1FF"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 109,
    cy: 125,
    r: 4,
    fill: "#EDF1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 59C144.523 59 149 63.4772 149 69V72.104L156.959 76.7107C158.348 77.5148 158.346 79.5211 156.955 80.3221L149 84.9038V89C149 94.5228 144.523 99 139 99H85C79.4771 99 75 94.5228 75 89V69C75 63.4772 79.4771 59 85 59H139Z",
    fill: "#FFC93C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 8,
    transform: "matrix(-1 0 0 1 136 75)",
    fill: "#FFC93C"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(-1 0 0 1 136 75)",
    fill: "#4F75FF"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(-1 0 0 1 122 75)",
    fill: "#4F75FF"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(-1 0 0 1 108 75)",
    fill: "#4F75FF"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(-1 0 0 1 93.9999 75)",
    fill: "#4F75FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSpeakingEnglish);
export default __webpack_public_path__ + "static/media/home_speaking_english.620a6d6ccc29eff493f5d6ac1ba5bc87.svg";
export { ForwardRef as ReactComponent };